export enum RosterProgressStatuses {
  Canceled = 0,
  New = 1,
  Certified = 2,
  Endorsed = 3,
  TransferredWithdrawn = 4
}
